import { render } from "./CustomPassword.vue?vue&type=template&id=0cdc3fd8&scoped=true"
import script from "./CustomPassword.vue?vue&type=script&lang=js"
export * from "./CustomPassword.vue?vue&type=script&lang=js"

import "./CustomPassword.vue?vue&type=style&index=0&id=0cdc3fd8&scoped=true&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cdc3fd8"]])

export default __exports__